import { Activity } from 'lucide-react';
import DataFreshnessPanel from './DataFreshnessPanel';
import SystemHealthCards, { type SystemHealthCardsProps } from './SystemHealthCards';

/** System Health page body: data freshness on top, then the four health cards with 7-day trends. */
export default function SystemHealthPage(props: SystemHealthCardsProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-11 h-11 rounded-lg bg-blue-500/10 border border-blue-500/30">
          <Activity className="w-6 h-6 text-blue-400" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-white">System Health</h1>
          <p className="text-sm text-gray-400">How fresh each source is, and how each area has trended over the last 7 days</p>
        </div>
      </div>
      <DataFreshnessPanel demo={props.useMockData === true} />
      <SystemHealthCards {...props} />
    </div>
  );
}
